export class TenantInvoiceAddress {
  id: string | undefined;
  name: string | undefined;
  addressLine0: string | undefined;
  addressLine1: string | undefined;
  postalCode: string | undefined;
  country: string | undefined;
  city: string | undefined;
  vatNumber: string | undefined;
  vatType: string | undefined;

  constructor(payload?: any) {
    if (payload) {
      this.id = payload.id;
      this.name = payload?.name;
      this.addressLine0 = payload?.addressLine0;
      this.addressLine1 = payload?.addressLine1;
      this.postalCode = payload?.postalCode;
      this.country = payload?.country;
      this.city = payload?.city;
      this.vatNumber = payload?.vatNumber;
      this.vatType = payload?.vatType;
    }
  }

}
